(function () {

  'use strict';

  angular
    .module('app')
    .controller('buildingCtrl', ['$scope', '$stateParams', 'ServerData', 'Months', 'serverCalls', 'data', buildingCtrl]);

    function buildingCtrl ($scope, $stateParams, ServerData, Months, serverCalls, data) {

      /* jshint validthis: true */
      var vm = this,
          barTemp = 0,
          element1 = document.querySelector('#barTemp'),
          element2 = document.querySelector('#barTemp2'),
          savingsOptions = {};

      // Defining variables needed
      vm.tplName = $stateParams.name;
      vm.tplMode = $stateParams.mode;
      vm.urlFiles = ServerData.FILES_URL + '/files/' + ServerData.ENV + '/fandeck/' + $stateParams.uid + '/';
      vm.room1free = true;
      vm.room2free = false;
      vm.isSaving = false;
      vm.date = moment(data.rooms[0].datetime).format();
      vm.room1Data = data.rooms[0];
      vm.room2Data = data.rooms[1];
      savingsOptions = {
        uid: $stateParams.uid,
        tplName: vm.tplName
      };
      serverCalls.getSavings(savingsOptions).then(function (response) {
        // console.log('Esto devuelve getSavings: ' + JSON.stringify(response));
        vm.savings = response;
        if (vm.savings.bars.length > 0) {
          vm.isSaving = true;
          vm.savings.cost_savings = Math.ceil(vm.savings.cost_savings);
          var arrayBars = vm.savings.bars;
          // console.log('Esto es bars antes de sort: ' + JSON.stringify(arrayBars));
          arrayBars.sort(function (a, b) {
            return parseFloat(a.year + a.month) - parseFloat(b.year + b.month);
          });
          // console.log('Esto es bars después de sort: ' + JSON.stringify(arrayBars));
          createChart();
          arrayBars = arrayBars.map(function (elem) {
            elem.month = Months[parseFloat(elem.month) - 1];
            return elem;
          });
          vm.savings.bars = arrayBars;
          // console.log('Esto es bars después de map: ' + JSON.stringify(arrayBars));
          createChart();
        }
      });
      if ( vm.tplName == 2 || vm.tplName == 4) {
        vm.electFanData = vm.room2Data.vars[2].current;
        vm.electFanBar = vm.room2Data.vars[2].current - 0.5;
      }
      vm.buildingType = data.buildingType;
      vm.buildingName = data.buildingName;
      vm.extTemp = data.extTemp;
      vm.saveEnergy = 268;
      vm.saveMoney = vm.saveEnergy * 0.14;
      barTemp = (parseFloat(data.extTemp) + 5) * 2;
      element1.style.width=barTemp + '%';
      element2.style.width=barTemp + '%';
      vm.countupOptionsTemp = {
        useEasing : true,
        useGrouping : true,
        separator : '.',
        decimal : ',',
        prefix : '',
        suffix : 'º'
      };
      vm.countupOptionsPot = {
        useEasing : true,
        useGrouping : true,
        separator : '.',
        decimal : ','
      };

      function createChart () {

        var chart = AmCharts.makeChart('chartdiv', {
          'type': 'serial',
          'theme': 'light',
          'fontFamily': 'MyriadRegular',
          'columnWidth': 0.3,
          'legend': {
            'horizontalGap': 10,
            'maxColumns': 1,
            'position': 'bottom',
            'useGraphSettings': true,
            'markerSize': 10
          },
          'dataProvider': vm.savings.bars,
          // [{
          //     'month': 'ENE',
          //     'electronic': 18,
          //     'standard': 47
          // }, {
          //     'month': 'FEB',
          //     'electronic': 20,
          //     'standard': 45
          // }, {
          //     'month': 'MAR',
          //     'electronic': 15,
          //     'standard': 42
          // }, {
          //     'month': 'ABR',
          //     'electronic': 11,
          //     'standard': 38
          // }, {
          //     'month': 'MAY',
          //     'electronic': 19,
          //     'standard': 48
          // }, {
          //     'month': 'JUN',
          //     'electronic': 16,
          //     'standard': 43
          // }, {
          //     'month': 'JUL',
          //     'electronic': 17,
          //     'standard': 43
          // }, {
          //     'month': 'AGO',
          //     'electronic': 15,
          //     'standard': 38
          // }, {
          //     'month': 'SEP',
          //     'electronic': 13,
          //     'standard': 32
          // }, {
          //     'month': 'OCT',
          //     'electronic': 10,
          //     'standard': 29
          // }, {
          //     'month': 'NOV',
          //     'electronic': 20,
          //     'standard': 49
          // }, {
          //     'month': 'DIC',
          //     'electronic': 17,
          //     'standard': 41
          // }],
          'valueAxes': [{
            'stackType': 'regular',
            // 'maximum': 60,
            'minimum': 0,
            'gridCount': 10,
            'dashLength': 2,
            'autoGridCount': false,
            'unit': ' kWh',
            'axisAlpha': 0.3,
            'gridAlpha': 0.1
          }],
          'graphs': [{
            'balloonText': '<b>[[title]]</b><br><span style="font-size:14px">[[category]]: <b>[[value]]</b></span>',
            'fillAlphas': 0.8,
            // 'labelText': '[[value]]',
            'lineAlpha': 0.3,
            'title': 'FANCOIL ELECTRÓNICO',
            'type': 'column',
            'color': '#000000',
            'fillColors':'#2e8ece',
            'lineColor': '#2e8ece',
            'valueField': 'electronic'
          },
          {
            'balloonText': '<b>[[title]]</b><br><span style="font-size:14px">[[category]]: <b>[[value]]</b></span>',
            'fillAlphas': 0.8,
            // 'labelText': '[[value]]',
            'lineAlpha': 0.3,
            'title': 'FANCOIL ESTÁNDAR',
            'type': 'column',
            'color': '#000000',
            'fillColors':'#BDBDBD',
            'lineColor': '#BDBDBD',
            'valueField': 'conventional'
          }],
          'categoryField': 'month',
          'categoryAxis': {
            'gridPosition': 'start',
            'axisAlpha': 0.3,
            'gridAlpha': 0,
            'position': 'left'
          },
          'export': {
            'enabled': true
          },
          'numberFormatter': {
            // 'precision': -1,
            'decimalSeparator': ',',
            'thousandsSeparator': '.'
          }

        });


      }

    }

}());